import { useContext } from 'react';
import {
  AuthenticationContext,
  AuthenticationContextValue,
} from './AuthenticationProvider';

export const useAuthentication = (): AuthenticationContextValue => {
  return useContext(AuthenticationContext);
};
